module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldSemiCnIt.08a53ec.woff";